export default function componentStyleOverrides(theme) {
    const bgColor = theme.colors?.grey50;
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '9px'
                },
                sizeLarge: {
                    padding: '13px 15px',
                    fontSize: '1.1rem'
                },
                gradient: {
                    background: `linear-gradient(85deg, ${theme.defaultMain} 2%, ${theme.defaultMain}94 100%)`,
                    color: theme.paperLight
                },
                containedSuccess: {
                    color: theme.colors?.primaryLight
                },
                startIcon: {
                    marginRight: '-4px',
                    marginLeft: '8px'
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    '&.MuiDialog-paper': {
                        '@media (max-width: 800px)': {
                            background: theme.colors?.primaryLight
                        }
                        /*
                        '@media (min-width: 801px)': {
                            width: 'calc(100% - 5px)',
                            maxHeight: 'calc(100% - 5px)',
                            margin: '5px'
                        }
                        */
                    }
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '15px',
                    '&:last-child': {
                        paddingBottom: '15px'
                    }
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                },
                root: {
                    textAlign: 'right'
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    padding: '0 !important',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.colors?.grey200
                    },
                    '&:hover $notchedOutline': {
                        borderColor: theme.colors?.primaryLight
                    },
                    '&.MuiInputBase-multiline': {
                        padding: '0 0 0 0'
                    }
                },
                input: {
                    height: '1.5em',
                    fontWeight: 500,
                    background: theme.colors?.grey200,
                    padding: '13px 14px',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    borderColor: 'rgba(0, 0, 0, 0.13)'
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primaryLight
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        },
        MuiTabPanel: {
            styleOverrides: {
                root: {
                    padding: '1.25rem 0.3rem'
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    background: theme.colors?.paperLight,
                    padding: '16px !important'
                }
            }
        },

        // RTL
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    width: 'calc(100% - 20px)',
                    transformOrigin: 'top right',
                    top: '-1px'
                },
                shrink: {
                    width: 'calc(100% - 30px)',
                    display: 'none'
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    '&>label[data-shrink="false"]': {
                        top: '1px !important',
                        lineHeight: '0.875em'
                    }
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    textAlign: 'right'
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                action: {
                    marginRight: 'auto',
                    marginLeft: '-8px'
                },
                icon: {
                    marginLeft: '12px',
                    marginRight: 'unset'
                },
                filled: {
                    background: theme.colors?.grey600,
                    position: 'fixed',
                    top: 0,
                    borderRadius: 0,
                    padding: '16px 16px'
                },
                filledSuccess: {
                    color: theme.colors?.success500
                },
                filledError: {
                    color: theme.colors?.primaryLight
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: '13px',
                    paddingRight: '20px !important'
                },
                icon: {
                    left: '7px',
                    right: 'unset'
                },
                multiple: {
                    padding: '9px',
                    minHeight: '32px'
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                input: {
                    padding: '13px 15px !important'
                },
                endAdornment: {
                    right: 'unset !important',
                    left: '9px'
                }
            }
        },
        MuiCollapse: {
            styleOverrides: {
                root: {
                    '&.MuiTreeItem-groupTransition': {
                        paddingRight: '16px',
                        paddingLeft: 0
                    }
                }
            }
        },
        MuiTreeItem: {
            styleOverrides: {
                content: {
                    '& .MuiTreeItem-iconContainer': {
                        transform: 'scaleX(-1)'
                    }
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                '.MuiColorInput-PopoverBody .MuiSlider-rail': {
                    transform: 'translate(0px, -4px) scaleX(-1)'
                },
                '.MuiColorInput-PopoverBody .MuiSlider-thumb': {
                    transform: 'translate(10px, -10px)'
                },
                '.MuiColorInput-PopoverBody .MuiColorInput-AlphaSlider': {
                    marginTop: '10px'
                }
            }
        }
    };
}
